module.exports = __webpack_public_path__ + "img/9788954619936.b03d0e4e.jpg";